import React, { useState, useContext, useEffect } from "react";
import ClientsContext from "../../context/clients/clientsContext";
import AlertContext from "../../context/alert/alertContext";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";

const ClientForm = () => {
  const clientsContext = useContext(ClientsContext);
  const alertContext = useContext(AlertContext);
  const { setAlert } = alertContext;

  const { addClient, current, clearCurrent, updateClient } = clientsContext;

  useEffect(() => {
    if (current != null) {
      setClient(current);
    } else {
      setClient({
        name: "",
        contactName: "",
        contactEmail: "",
        contactPhone: ""
      });
    }
  }, [clientsContext, current]);

  const [client, setClient] = useState({
    name: "",
    contactName: "",
    contactEmail: "",
    contactPhone: ""
  });

  const { name, contactName, contactEmail, contactPhone } = client;

  const onChange = e => {
    setClient({ ...client, [e.target.name]: e.target.value });
  };

  const onChangePhone = value => {
    setClient({ ...client, contactPhone: value });
  };

  const onSubmit = e => {
    e.preventDefault();
    if (client.name !== "") {
      if (current === null) {
        addClient(client);
      } else {
        updateClient(client);
      }

      clearAll();
    } else {
      setAlert("Name cannot be blank", "danger");
    }
  };

  const clearAll = () => {
    clearCurrent();
  };

  return (
    <form onSubmit={onSubmit}>
      <h2 className="tex-primary">{current ? "Edit Client" : "Add Client"}</h2>
      <input
        type="text"
        name="name"
        placeholder="Name"
        value={name}
        onChange={onChange}
      />
      <input
        type="text"
        name="contactName"
        placeholder="Contact Name"
        value={contactName}
        onChange={onChange}
      />
      <input
        type="email"
        name="contactEmail"
        placeholder="Contact Email"
        value={contactEmail}
        onChange={onChange}
      />
      {/* <input
        type='text'
        name='contactPhone'
        placeholder='Contact Phone'
        value={contactPhone}
        onChange={onChange}
      /> */}
      <PhoneInput
        name="contactPhone"
        placeholder="Contact Phone"
        value={contactPhone}
        onChange={onChangePhone}
        country="US"
      />
      <div>
        <input
          type="submit"
          value={current ? "Update Client" : "Add Client"}
          className="btn btn-primary btn-block"
        />
      </div>
      {current && (
        <div>
          <button className="btn btn-light btn-block" onClick={clearAll}>
            Clear
          </button>
        </div>
      )}
    </form>
  );
};

export default ClientForm;
